// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsentPreview_root__45y1h","description":"PatientConsentPreview_description__PWsJA"};